/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IntegrationTriggerRuleDto,
  TriggerEvaluateRequest,
} from '../models/index';
import {
    IntegrationTriggerRuleDtoFromJSON,
    IntegrationTriggerRuleDtoToJSON,
    TriggerEvaluateRequestFromJSON,
    TriggerEvaluateRequestToJSON,
} from '../models/index';

export interface CreateRule1Request {
    integrationTriggerRuleDto: IntegrationTriggerRuleDto;
    sessionId?: string;
}

export interface DeleteRule1Request {
    ruleId: string;
    sessionId?: string;
}

export interface EvaluateRequest {
    triggerEvaluateRequest: TriggerEvaluateRequest;
    sessionId?: string;
}

export interface GetIntentRequest {
    intentId: string;
    sessionId?: string;
}

export interface GetRuleRequest {
    ruleId: string;
    sessionId?: string;
}

export interface ListAuditRequest {
    sessionId?: string;
    ruleId?: string;
    intentId?: string;
    outcome?: string;
    instanceId?: string;
    page?: number;
    size?: number;
}

export interface ListIntentsRequest {
    sessionId?: string;
    status?: string;
    instanceId?: string;
    mappingId?: string;
    effectTenantId?: string;
    page?: number;
    size?: number;
}

export interface ListRulesRequest {
    instanceId?: string;
    mappingId?: string;
}

export interface ListTriggerableEntitiesRequest {
    enabledOnly?: boolean;
}

export interface PerformanceRequest {
    sessionId?: string;
    instanceId?: string;
    lookbackDays?: number;
}

export interface UpdateRule1Request {
    ruleId: string;
    integrationTriggerRuleDto: IntegrationTriggerRuleDto;
    sessionId?: string;
}

/**
 * IntegrationTriggersApi - interface
 * 
 * @export
 * @interface IntegrationTriggersApiInterface
 */
export interface IntegrationTriggersApiInterface {
    /**
     * 
     * @summary Create a trigger rule
     * @param {IntegrationTriggerRuleDto} integrationTriggerRuleDto 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationTriggersApiInterface
     */
    createRule1Raw(requestParameters: CreateRule1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Create a trigger rule
     */
    createRule1(requestParameters: CreateRule1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Delete a trigger rule
     * @param {string} ruleId 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationTriggersApiInterface
     */
    deleteRule1Raw(requestParameters: DeleteRule1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Delete a trigger rule
     */
    deleteRule1(requestParameters: DeleteRule1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Dry-run trigger rule evaluation against a sample envelope
     * @param {TriggerEvaluateRequest} triggerEvaluateRequest 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationTriggersApiInterface
     */
    evaluateRaw(requestParameters: EvaluateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Dry-run trigger rule evaluation against a sample envelope
     */
    evaluate(requestParameters: EvaluateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Get trigger intent detail
     * @param {string} intentId 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationTriggersApiInterface
     */
    getIntentRaw(requestParameters: GetIntentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get trigger intent detail
     */
    getIntent(requestParameters: GetIntentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Get a trigger rule by id
     * @param {string} ruleId 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationTriggersApiInterface
     */
    getRuleRaw(requestParameters: GetRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get a trigger rule by id
     */
    getRule(requestParameters: GetRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Trigger intent queue depth and oldest pending age
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationTriggersApiInterface
     */
    intentBacklogRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Trigger intent queue depth and oldest pending age
     */
    intentBacklog(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Paginated trigger audit log
     * @param {string} [sessionId] 
     * @param {string} [ruleId] 
     * @param {string} [intentId] 
     * @param {string} [outcome] 
     * @param {string} [instanceId] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationTriggersApiInterface
     */
    listAuditRaw(requestParameters: ListAuditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Paginated trigger audit log
     */
    listAudit(requestParameters: ListAuditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary List trigger intents with lifecycle filters
     * @param {string} [sessionId] 
     * @param {string} [status] 
     * @param {string} [instanceId] 
     * @param {string} [mappingId] 
     * @param {string} [effectTenantId] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationTriggersApiInterface
     */
    listIntentsRaw(requestParameters: ListIntentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * List trigger intents with lifecycle filters
     */
    listIntents(requestParameters: ListIntentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary List trigger rules for an instance or mapping
     * @param {string} [instanceId] 
     * @param {string} [mappingId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationTriggersApiInterface
     */
    listRulesRaw(requestParameters: ListRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * List trigger rules for an instance or mapping
     */
    listRules(requestParameters: ListRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary List entity types available for trigger rules
     * @param {boolean} [enabledOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationTriggersApiInterface
     */
    listTriggerableEntitiesRaw(requestParameters: ListTriggerableEntitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * List entity types available for trigger rules
     */
    listTriggerableEntities(requestParameters: ListTriggerableEntitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Trigger latency percentiles for monitoring widgets
     * @param {string} [sessionId] 
     * @param {string} [instanceId] 
     * @param {number} [lookbackDays] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationTriggersApiInterface
     */
    performanceRaw(requestParameters: PerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Trigger latency percentiles for monitoring widgets
     */
    performance(requestParameters: PerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Update a trigger rule
     * @param {string} ruleId 
     * @param {IntegrationTriggerRuleDto} integrationTriggerRuleDto 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationTriggersApiInterface
     */
    updateRule1Raw(requestParameters: UpdateRule1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Update a trigger rule
     */
    updateRule1(requestParameters: UpdateRule1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class IntegrationTriggersApi extends runtime.BaseAPI implements IntegrationTriggersApiInterface {

    /**
     * Create a trigger rule
     */
    async createRule1Raw(requestParameters: CreateRule1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['integrationTriggerRuleDto'] == null) {
            throw new runtime.RequiredError(
                'integrationTriggerRuleDto',
                'Required parameter "integrationTriggerRuleDto" was null or undefined when calling createRule1().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/integration/triggers/rules`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IntegrationTriggerRuleDtoToJSON(requestParameters['integrationTriggerRuleDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Create a trigger rule
     */
    async createRule1(requestParameters: CreateRule1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.createRule1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a trigger rule
     */
    async deleteRule1Raw(requestParameters: DeleteRule1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['ruleId'] == null) {
            throw new runtime.RequiredError(
                'ruleId',
                'Required parameter "ruleId" was null or undefined when calling deleteRule1().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integration/triggers/rules/{ruleId}`;
        urlPath = urlPath.replace(`{${"ruleId"}}`, encodeURIComponent(String(requestParameters['ruleId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Delete a trigger rule
     */
    async deleteRule1(requestParameters: DeleteRule1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.deleteRule1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Dry-run trigger rule evaluation against a sample envelope
     */
    async evaluateRaw(requestParameters: EvaluateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['triggerEvaluateRequest'] == null) {
            throw new runtime.RequiredError(
                'triggerEvaluateRequest',
                'Required parameter "triggerEvaluateRequest" was null or undefined when calling evaluate().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/integration/triggers/evaluate`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TriggerEvaluateRequestToJSON(requestParameters['triggerEvaluateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Dry-run trigger rule evaluation against a sample envelope
     */
    async evaluate(requestParameters: EvaluateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.evaluateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get trigger intent detail
     */
    async getIntentRaw(requestParameters: GetIntentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['intentId'] == null) {
            throw new runtime.RequiredError(
                'intentId',
                'Required parameter "intentId" was null or undefined when calling getIntent().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integration/triggers/intents/{intentId}`;
        urlPath = urlPath.replace(`{${"intentId"}}`, encodeURIComponent(String(requestParameters['intentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get trigger intent detail
     */
    async getIntent(requestParameters: GetIntentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getIntentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a trigger rule by id
     */
    async getRuleRaw(requestParameters: GetRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['ruleId'] == null) {
            throw new runtime.RequiredError(
                'ruleId',
                'Required parameter "ruleId" was null or undefined when calling getRule().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integration/triggers/rules/{ruleId}`;
        urlPath = urlPath.replace(`{${"ruleId"}}`, encodeURIComponent(String(requestParameters['ruleId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get a trigger rule by id
     */
    async getRule(requestParameters: GetRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Trigger intent queue depth and oldest pending age
     */
    async intentBacklogRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integration/triggers/intents/backlog`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Trigger intent queue depth and oldest pending age
     */
    async intentBacklog(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.intentBacklogRaw(initOverrides);
        return await response.value();
    }

    /**
     * Paginated trigger audit log
     */
    async listAuditRaw(requestParameters: ListAuditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['ruleId'] != null) {
            queryParameters['ruleId'] = requestParameters['ruleId'];
        }

        if (requestParameters['intentId'] != null) {
            queryParameters['intentId'] = requestParameters['intentId'];
        }

        if (requestParameters['outcome'] != null) {
            queryParameters['outcome'] = requestParameters['outcome'];
        }

        if (requestParameters['instanceId'] != null) {
            queryParameters['instanceId'] = requestParameters['instanceId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integration/triggers/audit`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Paginated trigger audit log
     */
    async listAudit(requestParameters: ListAuditRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.listAuditRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List trigger intents with lifecycle filters
     */
    async listIntentsRaw(requestParameters: ListIntentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['instanceId'] != null) {
            queryParameters['instanceId'] = requestParameters['instanceId'];
        }

        if (requestParameters['mappingId'] != null) {
            queryParameters['mappingId'] = requestParameters['mappingId'];
        }

        if (requestParameters['effectTenantId'] != null) {
            queryParameters['effectTenantId'] = requestParameters['effectTenantId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integration/triggers/intents`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * List trigger intents with lifecycle filters
     */
    async listIntents(requestParameters: ListIntentsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.listIntentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List trigger rules for an instance or mapping
     */
    async listRulesRaw(requestParameters: ListRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['instanceId'] != null) {
            queryParameters['instanceId'] = requestParameters['instanceId'];
        }

        if (requestParameters['mappingId'] != null) {
            queryParameters['mappingId'] = requestParameters['mappingId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integration/triggers/rules`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * List trigger rules for an instance or mapping
     */
    async listRules(requestParameters: ListRulesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.listRulesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List entity types available for trigger rules
     */
    async listTriggerableEntitiesRaw(requestParameters: ListTriggerableEntitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['enabledOnly'] != null) {
            queryParameters['enabledOnly'] = requestParameters['enabledOnly'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integration/triggers/triggerable-entities`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * List entity types available for trigger rules
     */
    async listTriggerableEntities(requestParameters: ListTriggerableEntitiesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.listTriggerableEntitiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Trigger latency percentiles for monitoring widgets
     */
    async performanceRaw(requestParameters: PerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['instanceId'] != null) {
            queryParameters['instanceId'] = requestParameters['instanceId'];
        }

        if (requestParameters['lookbackDays'] != null) {
            queryParameters['lookbackDays'] = requestParameters['lookbackDays'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integration/triggers/performance`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Trigger latency percentiles for monitoring widgets
     */
    async performance(requestParameters: PerformanceRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.performanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a trigger rule
     */
    async updateRule1Raw(requestParameters: UpdateRule1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['ruleId'] == null) {
            throw new runtime.RequiredError(
                'ruleId',
                'Required parameter "ruleId" was null or undefined when calling updateRule1().'
            );
        }

        if (requestParameters['integrationTriggerRuleDto'] == null) {
            throw new runtime.RequiredError(
                'integrationTriggerRuleDto',
                'Required parameter "integrationTriggerRuleDto" was null or undefined when calling updateRule1().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/integration/triggers/rules/{ruleId}`;
        urlPath = urlPath.replace(`{${"ruleId"}}`, encodeURIComponent(String(requestParameters['ruleId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IntegrationTriggerRuleDtoToJSON(requestParameters['integrationTriggerRuleDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Update a trigger rule
     */
    async updateRule1(requestParameters: UpdateRule1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.updateRule1Raw(requestParameters, initOverrides);
        return await response.value();
    }

}
